import { AppointmentSortTypes } from ".";

export enum HealthFlowSteps {
  listAppointments = "listAppointments",
  doAppointment = "doAppointment",
  organizationUnit = "organizationUnit",
  speciality = "speciality",
  insurance = "insurance",
  insurancePlan = "insurancePlan",
  procedure = "procedure",
  doctor = "doctor",
  appointmentType = "appointmentType",
  planCategory = "planCategory",
  insuranceSubPlan = "insuranceSubPlan",
  occupationArea = "occupationArea",
  organizationUnitLocation = "organizationUnitLocation",
  group = "group",
  chooseDoctor = "choose_doctor",
  choosePeriodOfDay = "choose_day_period",
  listPatientSchedules = "listPatientSchedules",
  cancel = "cancel",
  confirmAppointment = "confirmAppointment",
  reschedule = "reschedule",
  typeOfService = "typeOfService",
  // confirmação feita pelo usuário no bot
  confirmPassive = "confirmPassive",
  // confirmação feita pelo usuário na confirmação
  confirmActive = "confirmActive",
  reason = "reason",
  confirmPresence = 'confirmPresence',
  appointmentValue = 'appointmentValue',
}

export enum FlowTriggerType {
  before_end_conversation = 'before_end_conversation',
  active_confirmation_confirm = 'active_confirmation_confirm',
  active_confirmation_cancel = 'active_confirmation_cancel',
}

export interface HealthFlow {
  description?: string;
  typeOfServiceId?: string[];
  organizationUnitId?: string[];
  insuranceId?: string[];
  insurancePlanId?: string[];
  specialityId?: string[];
  procedureId?: string[];
  insuranceSubPlanId?: string[];
  planCategoryId?: string[];
  organizationUnitLocationId?: string[];
  occupationAreaId?: string[];
  doctorId?: string[];
  appointmentTypeId?: string[];
  reasonId?: string[];
  integrationId: string;
  workspaceId: string;
  actions?: FlowAction[];
  type: FlowType;
  step?: HealthFlowSteps[];
  createdAt?: number;
  updatedAt?: number;
  updatedByUserId?: string;
  inactive?: boolean;
  minimumAge?: number;
  maximumAge?: number;
  periodOfDay?: FlowPeriodOfDay;
  cpfs?: string[];
  sex?: string;
  executeFrom?: number;
  executeUntil?: number;
  runBetweenStart?: number;
  runBetweenEnd?: number;
  trigger?: FlowTriggerType[];
  _id?: string;
}

export enum FlowPeriodOfDay {
  morning = 0,
  afternoon = 1,
  indifferent = 2,
}

export enum FlowType {
  omit = "omit",
  action = "action",
  correlation = "correlation",
  includeOnly = "includeOnly",
}

export enum FlowActionType {
  tag = "tag",
  postback = "postback",
  attribute = "attribute",
  goto = "goto",
  text = "text",
  rules = "rules",
  rulesConfirmation = "rulesConfirmation",
}

export interface FlowActionTag {
  action: "remove" | "add" | "remove-all";
  color: string;
  name: string;
}

export interface FlowActionPostback {
  value: string;
}

export interface FlowActionAttribute {
  action: "add" | "remove";
  label?: string;
  name?: string;
  type?: string;
  value: any;
  botId: string;
}

export interface FlowActionGoTo {
  workspaceId?: string;
  botId?: string;
  value: string;
}

export interface FlowActionText {
  text: string;
}

export interface FlowActionRules {
  price?: string;
  address?: string;
  skipIfOneItem?: boolean;
  skipIfNoItems?: boolean;
  limit?: number;
  randomize?: boolean;
  untilDay?: number;
  sortMethod?: AppointmentSortTypes;
  canNotCancel?: boolean;
  canNotConfirmPassive?: boolean;
  canNotConfirmActive?: boolean;
  canNotView?: boolean;
  canNotReschedule?: boolean;
  priority?: number;
  guidanceBeforeScheduled?: string;
  guidanceAfterScheduled?: string;
  fromDay?: number;
  skipSelection?: boolean;
  ifEmptyDataGoto?: string;
  noAvailableDatesMessage?: string;
}

export interface FlowActionConfirmationRules {
    onErrorGoto?: string;
    cancelGoto?: string;
    confirmationGoto?: string;
    rescheduleGoto?: string;
    notActionGoto?: string;

    cancelMessage?: string;
    confirmationMessage?: string;

    askReschedule?: boolean;
    cancelOnReschedule?: boolean;
    automaticallyReschedule?: boolean;
    cancelWithGoto?: boolean;
    sendGuidanceOnConfirmSchedule?: boolean;

    cancelReasonList?: number[];

    priority?: number;
}

export type FlowActionElement =
  | FlowActionTag
  | FlowActionAttribute
  | FlowActionPostback
  | FlowActionGoTo
  | FlowActionText
  | FlowActionRules
  | FlowActionConfirmationRules;

export interface FlowAction {
  type: FlowActionType;
  element: FlowActionElement;
}
